<div class="u-margin-top-l">
  <div class="c-section-title">
    <span class="c-section-title__text">{{ 'ALLOWANCES.DETAIL.SUMMARY.title' | translate }}</span>
    <span class="c-section-title__line"></span>
  </div>

  <!-- Desktop: Cards view -->
  <div class="u-hide-mobile">
    @for (paymentCalculation of summaryItem.paymentCalculations; track paymentCalculation) {
      <div class="c-summary-cards">
        <!-- Card 1: Document Info -->
        <div class="c-summary-card">
          <div class="c-summary-card__header">
            <h3 class="c-summary-card__title">{{ 'ALLOWANCES.DETAIL.SUMMARY.document' | translate }}</h3>
          </div>
          <div class="c-summary-card__body">
            <div class="c-summary-card__row">
              <span class="c-summary-card__label">{{ 'ALLOWANCES.DETAIL.SUMMARY.document' | translate }}</span>
              <div class="c-summary-card__value">
                {{summaryItem?.mainDocumentType}}
                <div class="c-summary-card__subtitle">{{getTranslatedData(summaryItem?.unemploymentTypeDescription)}}</div>
              </div>
            </div>
            <div class="c-summary-card__row">
              <span class="c-summary-card__label">{{ 'ALLOWANCES.DETAIL.SUMMARY.period' | translate }}</span>
              <span class="c-summary-card__value">{{paymentCalculation?.unemploymentInfo?.periodStart}}-{{paymentCalculation?.unemploymentInfo.periodEnd}}</span>
            </div>
            <div class="c-summary-card__row">
              <span class="c-summary-card__label">{{ 'ALLOWANCES.DETAIL.SUMMARY.office' | translate }}</span>
              <span class="c-summary-card__value">{{summaryItem?.office}}</span>
            </div>
          </div>
        </div>

        <!-- Card 2: Unemployment -->
        <div class="c-summary-card">
          <div class="c-summary-card__header">
            <h3 class="c-summary-card__title">{{ 'ALLOWANCES.DETAIL.SUMMARY.unemployment_group' | translate }}</h3>
          </div>
          <div class="c-summary-card__body">
            <div class="c-summary-card__row">
              <span class="c-summary-card__label">{{ 'ALLOWANCES.DETAIL.SUMMARY.days' | translate }}</span>
              <span class="c-summary-card__value">
                @if (summaryItem?.mainDocumentType ==='C3') {
                  <span (click)="op.toggle($event)" (keyup.enter)="op.toggle($event)" role="button" tabindex="0" class="popover">{{getFormattedNumber(paymentCalculation?.unemploymentInfo?.unemploymentDays, 1)}} <i class="fa fa-info-circle"></i></span>
                  <p-popover #op>
                    <div class="c-popover-days">
                      <div class="c-popover-days__header">
                        <strong>{{'FINANCIAL.POPOVER.C3.title' | translate}}</strong>
                      </div>
                      <div class="c-popover-days__grid">
                        <div><span>{{"FINANCIAL.POPOVER.C3.unemploymentDays" | translate}}:</span> <strong>{{ getFormattedNumber(paymentCalculation?.unemploymentInfo?.unemploymentDays, 1)}}</strong></div>
                        <div><span>{{"FINANCIAL.POPOVER.C3.sickDays" | translate}}:</span> <strong>{{ getFormattedNumber(paymentCalculation?.typeOfDays.sickDays, 1) }}</strong></div>
                        <div><span>{{"FINANCIAL.POPOVER.C3.sanctionDays" | translate}}:</span> <strong>{{ getFormattedNumber(paymentCalculation?.typeOfDays.sanctionDays, 1) }}</strong></div>
                        <div><span>{{"FINANCIAL.POPOVER.C3.exclusionDays" | translate}}:</span> <strong>{{ getFormattedNumber(paymentCalculation?.typeOfDays.exclusionDays, 1) }}</strong></div>
                        <div><span>{{"FINANCIAL.POPOVER.C3.nonPayedDays" | translate}}:</span> <strong>{{ getFormattedNumber(paymentCalculation?.typeOfDays.nonPayedDays, 1) }}</strong></div>
                        <div><span>{{"FINANCIAL.POPOVER.C3.employerHolidays" | translate}}:</span> <strong>{{ getFormattedNumber(paymentCalculation?.typeOfDays.employerHolidays, 1) }}</strong></div>
                      </div>
                    </div>
                  </p-popover>
                } @else {
                  {{getFormattedNumber(paymentCalculation?.unemploymentInfo?.unemploymentDays, 1)}}
                }
              </span>
            </div>
            <div class="c-summary-card__row">
              <span class="c-summary-card__label">{{ 'ALLOWANCES.DETAIL.SUMMARY.day_amount' | translate }}</span>
              <span class="c-summary-card__value">{{getCurrency(paymentCalculation?.unemploymentInfo?.currency)}} {{getFormattedNumber(paymentCalculation?.unemploymentInfo?.unemploymentDailyAmount)}}</span>
            </div>
            <div class="c-summary-card__row">
              <span class="c-summary-card__label">{{ 'ALLOWANCES.DETAIL.SUMMARY.barema' | translate }}</span>
              <span class="c-summary-card__value">{{paymentCalculation?.unemploymentInfo?.unemploymentBarema}}</span>
            </div>
            <div class="c-summary-card__row">
              <span class="c-summary-card__label">{{"ALLOWANCES.DETAIL.CALCULATIONS.withholding_tax" | translate}}</span>
              <span class="c-summary-card__value">{{getCurrency(paymentCalculation?.unemploymentInfo?.currency)}} -{{getFormattedNumber(paymentCalculation?.unemploymentInfo?.unemploymentHoldingTax)}}</span>
            </div>
            <div class="c-summary-card__row c-summary-card__row--total">
              <span class="c-summary-card__label">{{ 'ALLOWANCES.DETAIL.SUMMARY.amount' | translate }}</span>
              <span class="c-summary-card__value">{{getCurrency(paymentCalculation?.unemploymentInfo?.currency)}} {{getFormattedNumber(paymentCalculation?.unemploymentInfo?.unemploymentGrossAmount)}}</span>
            </div>
          </div>
        </div>

        <!-- Card 3: Additional Compensation -->
        <div class="c-summary-card">
          <div class="c-summary-card__header">
            <h3 class="c-summary-card__title">{{ 'ALLOWANCES.DETAIL.SUMMARY.compensation_group' | translate }}</h3>
          </div>
          <div class="c-summary-card__body">
            <div class="c-summary-card__row">
              <span class="c-summary-card__label">{{ 'ALLOWANCES.DETAIL.SUMMARY.number_alloc' | translate }}</span>
              <span class="c-summary-card__value">{{getFormattedNumber(paymentCalculation?.additionalCompensation?.additionalCompensationDays, 1)}}</span>
            </div>
            <div class="c-summary-card__row">
              <span class="c-summary-card__label">{{ 'ALLOWANCES.DETAIL.SUMMARY.barema_cmpl' | translate }}</span>
              <span class="c-summary-card__value">{{paymentCalculation?.additionalCompensation?.additionalCompensationBarema || '-'}}</span>
            </div>
            <div class="c-summary-card__row">
              <span class="c-summary-card__label">{{"ALLOWANCES.DETAIL.CALCULATIONS.witholding" | translate}}</span>
              <span class="c-summary-card__value">{{getCurrency(paymentCalculation?.unemploymentInfo?.currency)}} -{{getFormattedNumber(paymentCalculation?.additionalCompensation?.additionalCompensationHoldingTax)}}</span>
            </div>
            <div class="c-summary-card__row c-summary-card__row--total">
              <span class="c-summary-card__label">{{ 'ALLOWANCES.DETAIL.SUMMARY.amount' | translate }}</span>
              <span class="c-summary-card__value">{{getCurrency(paymentCalculation?.unemploymentInfo?.currency)}} {{getFormattedNumber(paymentCalculation?.additionalCompensation?.additionalCompensationGrossAmount)}}</span>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

  <!-- Mobile: Card view -->
  <div class="u-show-mobile">
    @for (paymentCalculation of summaryItem.paymentCalculations; track paymentCalculation; let i = $index) {
      <div class="c-detail-card">
        <!-- Card Header -->
        <div class="c-detail-card__header">
          <div class="c-detail-card__title">
            <span class="c-detail-card__doc-type">{{summaryItem?.mainDocumentType}}</span>
            <span class="c-detail-card__period">{{ 'ALLOWANCES.DETAIL.SUMMARY.period' | translate }}: {{paymentCalculation?.unemploymentInfo?.periodStart}}-{{paymentCalculation?.unemploymentInfo.periodEnd}}</span>
          </div>
          <div class="c-detail-card__subtitle">{{getTranslatedData(summaryItem?.unemploymentTypeDescription)}}</div>
        </div>

        <!-- Unemployment Section -->
        <div class="c-detail-card__section">
          <div class="c-detail-card__section-title">{{ 'ALLOWANCES.DETAIL.SUMMARY.amount_unemployment' | translate }}</div>
          <div class="c-detail-card__amount">
            <strong>{{getCurrency(paymentCalculation?.unemploymentInfo?.currency)}} {{getFormattedNumber(paymentCalculation?.unemploymentInfo?.unemploymentGrossAmount)}}</strong>
          </div>
          <div class="c-detail-card__grid">
            <div class="c-detail-card__item">
              <span class="c-detail-card__label">{{ 'ALLOWANCES.DETAIL.SUMMARY.days' | translate }}</span>
              <span class="c-detail-card__value">
                @if (summaryItem?.mainDocumentType ==='C3') {
                  <span (click)="toggleDaysDetail(i)" (keyup.enter)="toggleDaysDetail(i)" role="button" tabindex="0" class="popover">{{getFormattedNumber(paymentCalculation?.unemploymentInfo?.unemploymentDays, 1)}} <i class="fa fa-info-circle"></i></span>
                } @else {
                  {{getFormattedNumber(paymentCalculation?.unemploymentInfo?.unemploymentDays, 1)}}
                }
              </span>
            </div>
            <div class="c-detail-card__item">
              <span class="c-detail-card__label">{{ 'ALLOWANCES.DETAIL.SUMMARY.day_amount' | translate }}</span>
              <span class="c-detail-card__value">{{getCurrency(paymentCalculation?.unemploymentInfo?.currency)}} {{getFormattedNumber(paymentCalculation?.unemploymentInfo?.unemploymentDailyAmount)}}</span>
            </div>
            <div class="c-detail-card__item">
              <span class="c-detail-card__label">{{ 'ALLOWANCES.DETAIL.SUMMARY.barema' | translate }}</span>
              <span class="c-detail-card__value">{{paymentCalculation?.unemploymentInfo?.unemploymentBarema}}</span>
            </div>
            <div class="c-detail-card__item">
              <span class="c-detail-card__label">{{"ALLOWANCES.DETAIL.CALCULATIONS.withholding_tax" | translate}}</span>
              <span class="c-detail-card__value">{{getCurrency(paymentCalculation?.unemploymentInfo?.currency)}} -{{getFormattedNumber(paymentCalculation?.unemploymentInfo?.unemploymentHoldingTax)}}</span>
            </div>
          </div>
          <!-- Days detail popover for C3 -->
          @if (summaryItem?.mainDocumentType ==='C3' && activeDaysDetailIndex === i) {
            <div class="c-detail-card__days-detail">
              <div class="c-detail-card__days-detail-header">
                <strong>{{'FINANCIAL.POPOVER.C3.title' | translate}}</strong>
                <button (click)="toggleDaysDetail(-1)" class="c-detail-card__close"><i class="fa fa-times"></i></button>
              </div>
              <div class="c-detail-card__days-detail-grid">
                <div><span>{{"FINANCIAL.POPOVER.C3.unemploymentDays" | translate}}:</span> <strong>{{ getFormattedNumber(paymentCalculation?.unemploymentInfo?.unemploymentDays, 1)}}</strong></div>
                <div><span>{{"FINANCIAL.POPOVER.C3.sickDays" | translate}}:</span> <strong>{{ getFormattedNumber(paymentCalculation?.typeOfDays.sickDays, 1) }}</strong></div>
                <div><span>{{"FINANCIAL.POPOVER.C3.sanctionDays" | translate}}:</span> <strong>{{ getFormattedNumber(paymentCalculation?.typeOfDays.sanctionDays, 1) }}</strong></div>
                <div><span>{{"FINANCIAL.POPOVER.C3.exclusionDays" | translate}}:</span> <strong>{{ getFormattedNumber(paymentCalculation?.typeOfDays.exclusionDays, 1) }}</strong></div>
                <div><span>{{"FINANCIAL.POPOVER.C3.nonPayedDays" | translate}}:</span> <strong>{{ getFormattedNumber(paymentCalculation?.typeOfDays.nonPayedDays, 1) }}</strong></div>
                <div><span>{{"FINANCIAL.POPOVER.C3.employerHolidays" | translate}}:</span> <strong>{{ getFormattedNumber(paymentCalculation?.typeOfDays.employerHolidays, 1) }}</strong></div>
              </div>
            </div>
          }
        </div>

        <!-- Additional Compensation Section -->
        <div class="c-detail-card__section c-detail-card__section--alt">
          <div class="c-detail-card__section-title">{{ 'ALLOWANCES.DETAIL.SUMMARY.amount_BZ' | translate }}</div>
          <div class="c-detail-card__amount">
            <strong>{{getCurrency(paymentCalculation?.unemploymentInfo?.currency)}} {{getFormattedNumber(paymentCalculation?.additionalCompensation?.additionalCompensationGrossAmount)}}</strong>
          </div>
          <div class="c-detail-card__grid">
            <div class="c-detail-card__item">
              <span class="c-detail-card__label">{{ 'ALLOWANCES.DETAIL.SUMMARY.number_alloc' | translate }}</span>
              <span class="c-detail-card__value">{{getFormattedNumber(paymentCalculation?.additionalCompensation?.additionalCompensationDays, 1)}}</span>
            </div>
            <div class="c-detail-card__item">
              <span class="c-detail-card__label">{{ 'ALLOWANCES.DETAIL.SUMMARY.barema_cmpl' | translate }}</span>
              <span class="c-detail-card__value">{{paymentCalculation?.additionalCompensation?.additionalCompensationBarema || '-'}}</span>
            </div>
            <div class="c-detail-card__item">
              <span class="c-detail-card__label">{{"ALLOWANCES.DETAIL.CALCULATIONS.witholding" | translate}}</span>
              <span class="c-detail-card__value">{{getCurrency(paymentCalculation?.unemploymentInfo?.currency)}} -{{getFormattedNumber(paymentCalculation?.additionalCompensation?.additionalCompensationHoldingTax)}}</span>
            </div>
          </div>
        </div>

        <!-- Office info -->
        <div class="c-detail-card__footer">
          <span class="c-detail-card__label">{{ 'ALLOWANCES.DETAIL.SUMMARY.office' | translate }}:</span>
          <span class="c-detail-card__value">{{summaryItem?.office}}</span>
        </div>
      </div>
    }
  </div>
</div>
